import './menu_overlay.less';

import * as UI from '../ui';
import React   from 'react';


export default function MenuOverlay() {
  return <div className="menu-overlay" onClick={UI.closeMenu}/>;
}
